<template>
  <div>
    <main>
      <section>
        <div class="container">
          <div class="row">
            <mobileUserNav></mobileUserNav>

            <userInfo></userInfo>

            <div v-if="transcript" class="col_xl_8 col_l_8 col_m_8 col_s_12">
              <p class="user_title">{{ timeStamp(transcript.createdAt) }}</p>

              <div class="df s_betwen">
                <router-link to="/user_rooms" class="hover_op link_back">
                  <img src="@/assets/img/arrow_back_icon.svg" alt=""/>Rooms
                </router-link>

                <div class="share_wrap"
                     v-if="transcript.isOwner">
                  <recordingShareDrop
                      :share_link="localUrl"
                      :roomId="transcript.roomId"
                      :transcriptId="transcript.id"
                      :transcript="transcript"
                  ></recordingShareDrop>

                  <removeVideoDrop
                      :id="transcript.id"
                      :room_id="transcript.roomId"
                  ></removeVideoDrop>
                </div>
              </div>

              <div v-if="transcript.videos.length > 0">
                <div class="items_counter">
                  Video(s): {{ transcript.videos.length }}
                </div>

                <div
                    class="item"
                    v-for="recording in transcript.videos"
                    v-bind:key="recording.id"
                >
                  <button
                      class="hover_op size_dnld"
                      @click="setSelectedRecording(recording.id)"
                  >
                    {{ timeStampLong(recording.startTime) }}
                  </button>

                  <div class="size_dnld">
                    <a
                        download
                        :href="recording.link"
                        class="hover_op download"
                    ></a>
                  </div>
                </div>
              </div>

              <div>
                <div class="items_counter">Transcript(s): 1</div>

                <button class="item" @click="downloadTranscript">
                  <span
                      class="hover_op size_dnld"
                  >Transcript.txt</span
                  >

                  <span
                      class="hover_op download size_dnld"
                  ></span>
                </button>
              </div>

              <div v-if="transcript.participants.length">
                <div class="items_counter">
                  Participant(s): {{ transcript.participants.length }}
                </div>

                <div
                    class="modal_user"
                    v-for="partisipant in transcript.participants"
                    v-bind:key="partisipant.id"
                >
                  <participant-avatar :participant="partisipant"/>

                  <div class="name">{{ partisipant.username }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from "@/components/footerComponent.vue";
import userInfo from "@/components/userInfo.vue";
import Axios from "axios";
import mobileUserNav from "@/components/mobileUserNav.vue";
import removeVideoDrop from "@/components/recordings/removeVideoDrop.vue";
import recordingShareDrop from "@/components/recordings/recordingShareDrop.vue";
import {getAuth, onAuthStateChanged} from "firebase/auth";
import ParticipantAvatar from "../components/meeting/ParticipantAvatar";

export default {
  name: "Recordings",
  props: ["meetingId"],
  data() {
    return {
      user: null,
      transcript: null,
    };
  },

  components: {
    ParticipantAvatar,
    userInfo,
    footerComponent,
    mobileUserNav,
    removeVideoDrop,
    recordingShareDrop,
  },

  computed: {
    transcriptDownloadLink() {
      return `${process.env.VUE_APP_BACKEND_API_URL}/meetings/${this.meetingId}/transcript`
    },
    localUrl() {
      return new URL(document.location.toString());
    },
  },

  methods: {
    async GetTranscriptInfo() {
      try {
        this.transcript = await this.$store.dispatch("getMeetingById", this.meetingId)
      } catch (e) {
        if (this.user) {
          this.$store.dispatch("onError", "An error occurred")
        } else {
          this.$router.push(`/auth/login?returnTo=${window.location.pathname}`)
        }
      }
    },

    async downloadTranscript() {
      try {
        const url = await this.$store.dispatch("getMeetingTranscriptUrl", this.meetingId)
        window.open(url)
      } catch (e) {
        console.log(e)
        alert("An error occurred")
      }
    },

    timeStampLong(data) {
      return this.$moment(data).format("D MMM, YYYY, h:mm:ss");
    },

    timeStamp(data) {
      return this.$moment(data).format("D MMM, YYYY");
    },

    async setSelectedRecording(id) {
      this.$store.commit("showModal", "video_modal");

      const url = await this.$store.dispatch("getMeetingVideoUrl", {meetingId: this.meetingId, videoId: id})
      this.$store.commit(
          "setRecordVideoId",
          url
      );
    },
  },

  mounted() {
    onAuthStateChanged(getAuth(), (user) => {
      this.user = user
      this.GetTranscriptInfo()
    })()
  },
};
</script>

<style lang="scss" scoped>
.name {
  cursor: default;
}

.link_back {
  display: flex;
  align-items: center;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;

  img {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }
}

.share_wrap {
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  display: flex;
  align-items: center;
}

.items_counter {
  margin-top: 64px;
  margin-bottom: 32px;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.item {
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  justify-content: space-between;
  display: flex;
  align-items: center;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;
  padding-left: 20px;
  padding-right: 20px;

  & + .item {
    margin-top: 16px;
  }
}

.size_dnld {
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-transform: none;
}

.download {
  display: block;
  width: 24px;
  height: 24px;
  margin-left: 16px;
  background: url("../assets/img/download_icon.svg") no-repeat center / contain;
}
</style>
